export default __webpack_public_path__ + "static/media/tech-augmented-workforce.50e73924.svg";